"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 19 27",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.4516 6.81527V2.39145C18.451 1.86494 18.2415 1.36016 17.8692 0.98785C17.4969 0.615545 16.9921 0.40612 16.4656 0.405518L2.56406 0.405518C2.03754 0.40612 1.53276 0.615545 1.16046 0.98785C0.788153 1.36016 0.578727 1.86494 0.578125 2.39145L0.578125 6.85981C0.578851 7.16799 0.65095 7.4718 0.78877 7.74744C0.92659 8.02308 1.12638 8.26305 1.37249 8.44854L7.85994 13.3141L1.37255 18.1797C1.12643 18.3651 0.926617 18.6051 0.788786 18.8808C0.650954 19.1564 0.578849 19.4602 0.578125 19.7684L0.578125 24.2368C0.578727 24.7633 0.788153 25.2681 1.16046 25.6404C1.53276 26.0127 2.03754 26.2221 2.56406 26.2227H16.4656C16.9921 26.2221 17.4969 26.0127 17.8692 25.6404C18.2415 25.2681 18.451 24.7633 18.4516 24.2368V19.8129C18.4508 19.506 18.3792 19.2034 18.2425 18.9287C18.1057 18.6539 17.9075 18.4144 17.6631 18.2286L11.1615 13.3141L17.6632 8.39957C17.9075 8.21385 18.1058 7.9743 18.2425 7.69953C18.3792 7.42476 18.4508 7.12217 18.4516 6.81527ZM16.4656 2.39145V5.36981L2.56406 5.36981V2.39145L16.4656 2.39145ZM16.4656 24.2368H2.56406L2.56406 19.7684L9.51254 14.5571L16.4656 19.8129V24.2368Z",
    fill: fill
  }));
};

exports["default"] = _default;